import { useLottie } from 'lottie-react';
import React, { useEffect } from 'react';
import parse from 'html-react-parser';
import pinAnimation from '../../../assets/images/games/zdar-kids-game/pin.json';

type Props = {
    currentStep: number;
};

const items = [
    {
        id: 1,
        showOnStep: 3,
        title: `<h5><b>1. Zámecká kavárna</b></h5>`,
        texts: [
            `<p>
                Tady jsme se seznámili s <b>Míšou</b>, kocourem, který rád řeší záhady a zná Žďár skrz naskrz. Společně jsme se dohodli, že zjistíme, proč se říká <b>Zelené hoře zelená</b>. On sám měl totiž teorii, že je to podle stromů. Těch tu ale už moc není, takže tomu chtěl přijít na kloub.
            </p>`,
        ],
    },
    {
        id: 2,
        showOnStep: 5,
        title: `<h5><b>2. Most</b></h5>`,
        texts: [
            `<p>
                Bafl tu na nás duch <b>upíra Ulricha</b>, který se nám svěřil, že tu byl kdysi správcem. Protože byl ale zlý, tak tu musí strašit. Pomohli jsme ho osvobodit tím, že jsme <b>uhodli, co je zač</b>.
            </p>`,
            `<p>
                Zjistili jsme od něj, že most se jmenuje <b>červený</b>, protože tady pil lidem krev, ale že o barvě té hory nic neví, on tam nechodí, protože je tam moc slunce.
            </p>`,
        ],
    },
    {
        id: 3,
        showOnStep: 6,
        title: `<h5><b>3. Pod schody</b></h5>`,
        texts: [
            `<p>
                Další duch, který se nám zjevil, byl <b>mušketýr a jeho pes</b>. Za jeho časů se zdejší okolí jmenovalo <b>Temný les</b>, protože to tu bylo samý strom, a tak sem nesvítilo skoro žádné slunce.
            </p>`,
            `<p>
                Za odměnu jsme mu pomohli <b>roztřídit pohádkové postavy</b>, o kterých od dětí slýchá, ale sám je nezná.
            </p>`,
        ],
    },
    {
        id: 4,
        showOnStep: 8,
        title: `<h5><b>4. Rozcestí</b></h5>`,
        texts: [
            `<p>
                Na blízkém rozcestí si náš průvodce <b>pejsek</b> postěžoval, že je tady v rybníce spousta věcí, co tam nepatří a my mu pomohli je z něj <b>odstranit</b>.
            </p>`,
        ],
    },
    {
        id: 5,
        showOnStep: 10,
        title: `<h5><b>5. Lavička</b></h5>`,
        texts: [
            `<p>
                Potkali jsme se s <b>hraběnkou</b>, které seděla na lavičce a dívala se přes rybník. Podle ní by se to tu mělo jmenovat spíš <b>Růžová hora</b>. Stejnou barvu má totiž její komnata i zámek, na který se dívala. Zelená ji napadla možná kvůli té <b>krásné trávě</b>, co tu je.
            </p>`,
            `<p>
                 Abychom se dozvěděli, kam jít dál, tak jsme jí museli pomoct <b>přečíst písmeno</b> na lavičce, kde seděla.
            </p>`,
        ],
    },
    {
        id: 6,
        showOnStep: 13,
        title: `<h5><b>6. Značka</b></h5>`,
        texts: [
            `<p>
                 Na chvilku jsme se zastavili u značky: <b>Zákaz zastavení</b>, kterou jsme měli za úkol poznat. Kvůli podezíravému pohledu hraběnky jsme potom vyrazili <b>pozpátku</b> dál. 
            </p>`,
        ],
    },
    {
        id: 7,
        showOnStep: 19,
        title: `<h5><b>7. Autobusová zastávka</b></h5>`,
        texts: [
            `<p>
                Moc nám to <b>hledání nešlo</b>, tak jsme si ho pořádně procvičili na autobusové zastávce kousek od kostela. Zkoušeli jsme <b>hledat a počítat</b> nejrůznější věci v okolí.
            </p>`,
        ],
    },
    {
        id: 8,
        showOnStep: 22,
        title: `<h5><b>8. Dřevěný most I.</b></h5>`,
        texts: [
            `<p>
                Duch <b>dřevorubce</b> nám prozradil, že tu kdysi pomáhal kácet všechny ty stromy. Řekli jsme mu <b>tajemství</b> a on nás pustil za odměnu přes most, který střežil. Zachránili jsme ho tím, že jsme přečetli <b>5. slovo</b> z nedaleké cedulky.
            </p>`,
        ],
    },
    {
        id: 9,
        showOnStep: 24,
        title: `<h5><b>9. Dřevěný most II.</b></h5>`,
        texts: [
            `<p>
                <b>Bratr</b> dřevorubce po nás chtěl vědět, <b>koho všeho jsme už potkali</b>, aby s bratrem našli konečně klid a byli volní.
            </p>`,
            `<p>
                Řekl nám, že je tu okolo hodně <b>močálů</b>, takže podle něj by se to mělo jmenovat spíše <b>Hnědá hora</b>.
            </p>`,
        ],
    },
    {
        id: 10,
        showOnStep: 29,
        title: `<h5><b>10. U kostela</b></h5>`,
        texts: [
            `<p>
                Samotný <b>opat Vejmluva</b> se nám svěřil, že to on nechal Černý les pokácet, aby tu mohl postavit kostel. Většina zbylých stromů nakonec bohužel <b>shořela</b> společně s kostelem. Ten se nechal opravit, stromy už ale nenarostly.
            </p>`,
            `<p>
                Aby nás poslal dál, museli jsme mu zodpovědět několik <b>otázek</b> ohledně kostela.
            </p>`,
        ],
    },
    {
        id: 11,
        showOnStep: 32,
        title: `<h5><b>11. Stojan na kola I.</b></h5>`,
        texts: [
            `<p>
                Společně s <b>kočkou Lindou</b> jsme se vydali prozkoumávat samotný kostel. Našli jsme hned několik <b>zajímavých míst</b>.
            </p>`,
            `<p>
                Zvažovali jsme, jestli neměl upír Ulrich pravdu, spousta věcí totiž byla <b>červená</b>.
            </p>`,
        ],
    },
    {
        id: 12,
        showOnStep: 33,
        title: `<h5><b>12. Stojan na kola II.</b></h5>`,
        texts: [
            `<p>
                Zacvičili jsme si a po chvilce přemýšlení jsme se vydali k zajímavému <b>velikému stromu</b> v okolí, kde se proslýchá, že žije další duch.
            </p>`,
        ],
    },
    {
        id: 13,
        showOnStep: 34,
        title: `<h5><b>13. Strom</b></h5>`,
        texts: [
            `<p>
                Konečně se to všechno rozuzlovalo. Duch <b>svatého Nepomuka</b> nám odpověděl na naši hlavní otázku, proč se říká Zelené hoře zelená. On sám se totiž <b>narodil na Zelené hoře a opat Vejmluva potom pojmenoval tohle místo stejně na jeho počest</b>.
            </p>`,
            `<p>
                Za odměnu jsme šli odpočívat na hřiště.
            </p>`,
        ],
    },
];

export default function ZdarKidsReport({ currentStep }: Props) {
    const showItems = () => {
        const filtered = items.filter((item) => item.showOnStep <= currentStep);
        return (
            <>
                {filtered.map((item) => {
                    return (
                        <div key={item.id}>
                            <div className="zdar-kids-report-item-title">
                                <div className="icon">
                                    <PinImage />
                                </div>
                                {parse(item.title)}
                            </div>
                            {item.texts.map((text, i) => {
                                return <div key={i}>{parse(text)}</div>;
                            })}
                        </div>
                    );
                })}
            </>
        );
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <div className="zdar-kids-report">
                <div className="task-title">
                    <div className="task-title-text">Shrnutí pro rodiče</div>
                </div>
                <div className="task-text">
                    Na této stránce najdete shrnutí, co ste zažili na minulých stanovištích. Pokud si potřebujete
                    připomenout část příběhu, můžete to udělat tady.
                </div>
                <div className="task-text">{showItems()}</div>
            </div>
        </React.Fragment>
    );
}

const PinImage = () => {
    const options = {
        animationData: pinAnimation,
        loop: true,
        autoplay: true,
    };

    const { View } = useLottie(options);

    return View;
};
